import React from 'react';
import { withRouter } from 'react-router-dom';
import PrimaryButton from 'components/PrimaryButton';
import PATHNAMES from 'constants/pathnames';

const LoginButton = ({ history, staticContext, ...rest }) => (
  <PrimaryButton
    onClick={() => history.push(PATHNAMES.LOGIN)}
    style={{ minWidth: '100px' }}
    {...rest}
  >
    LOG IN
  </PrimaryButton>
);

export default withRouter(LoginButton);
